// extracted by mini-css-extract-plugin
export default {"rating":"WO-z","numberOfStars":"XO-z","count":"YO-z","barGraphSpacing":"ZO-z","barGraph":"_O-z"};